import axios from "axios";
import { defaultConfig, objectToQueryString } from "./helpers";
import { API_URL } from "./environment";

const request = ({
  method,
  url,
  params,
  body,
  baseURL,
  contentType = "application/json",
  shouldResolve = true,
  cancelToken,
}) => {
  //ApiDebugObject
  // const ApiDebugObject = {
  //   des: "Request Details",
  //   url: url,
  //   params: params,
  //   body: body,
  //   contentType: contentType,
  // };
  //  console.table(ApiDebugObject)

  return new Promise((resolve, reject) => {
    axios
      .request({
        url,
        baseURL: baseURL || API_URL,
        method,
        headers: defaultConfig.headers(contentType),
        params: params ? params : undefined,
        data: method !== "get" ? body : undefined,
        paramsSerializer: objectToQueryString,
        ...(cancelToken ? { cancelToken: cancelToken } : {}),
      })
      .then((response) => {
        // console.log(response)
        if (shouldResolve) {
          if (
            response.data.status === 200 ||
            response.data.statusCode === 200
          ) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        } else {
          resolve(response);
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};
export const peopleApi = {
  get: (args) => request({ method: "get", ...args }),
  post: (args) => request({ method: "post", ...args }),
  delete: (args) => request({ method: "delete", ...args }),
};
